import { Routes, Route } from "react-router-dom";
import { UserContextProvider } from "./contexts/UserContext";
import Navigation from "./pages/Navigation/Navigation";
import Applications from "./pages/Applications/Applications";
import Application from "./pages/Application/Application";
import CreateEditApplication from "./pages/CreateEditApplication/CreateEditApplication";
import ApplicationVersion from "./pages/ApplicationVersion/ApplicationVersion";
import CreateApplicationVersion from "./pages/CreateApplicationVersion/CreateApplicationVersion";
import CreateVersionSigning from "./pages/CreateVersionSigning/CreateVersionSigning";
import Signing from "./pages/Signing/Signing";
import None from "./pages/None/None";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import Login from "./pages/Login/Login";
import { myHistory } from "./api/config/history";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import ProtectedRoutes from "./components/ProtectedRoutes/ProtectedRoutes";

function App() {
  return (
    <UserContextProvider>
      <HistoryRouter history={myHistory}>
        <Routes>
          <Route path="/" element={<Navigation />}>
            <Route element={<ProtectedRoutes />}>
              <Route index element={<Applications />} />
              <Route
                path="application/:applicationId"
                element={<Application />}
              />
              <Route
                path="application/:applicationId/edit"
                element={<CreateEditApplication />}
              />
              <Route
                path="application/create"
                element={<CreateEditApplication />}
              />
              <Route
                path="application/:applicationId/version/:versionId"
                element={<ApplicationVersion />}
              />
              <Route
                path="application/:applicationId/version/create"
                element={<CreateApplicationVersion />}
              />
              <Route
                path="application/:applicationId/version/:versionId/signing/:signingId"
                element={<Signing />}
              />
              <Route
                path="application/:applicationId/version/:versionId/signing/create"
                element={<CreateVersionSigning />}
              />
            </Route>
            <Route element={<Login />} path="login" />
            <Route path="*" element={<None />} />
          </Route>
        </Routes>
      </HistoryRouter>
    </UserContextProvider>
  );
}

export default App;
